import React, { useEffect, useState } from "react";
import { Pencil } from "lucide-react";
import Avatar from "../ui/Avatar";
import Button from "../ui/Button";
import { useAppSelector } from "src/redux/hooks";
import AdminProfileForm from "../forms/ProfileFormAdmin";

interface ProfileCardAdminProps {
  userType: "admin" | "tenant";
}

const ProfileCardAdmin: React.FC<ProfileCardAdminProps> = ({
  userType = "tenant",
}) => {
  const {
    user: { data: user },
  } = useAppSelector((state) => state.authAdmin);

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (user) {
      setIsEditing(false);
    }
  }, [user]);

  return (
    <div className="w-full md:w-2/3 mx-auto">
      <div className="flex flex-col items-center justify-center space-y-3">
        <div className="relative">
          <Avatar link={user?.avatar || ""} name={user?.firstName || ""} />
          {/* <button
            className="absolute bottom-0 right-0 bg-indigo-600 text-white rounded-full p-1.5 shadow-md"
            onClick={() => toast.info("Avatar upload coming soon")}
          >
            <Pencil className="w-3 h-3" />
          </button> */}
        </div>

        {!isEditing ? (
          <>
            <div className="text-lg font-semibold text-gray-800">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="text-sm text-gray-500">{user?.email}</div>
            <div className="text-sm text-gray-500 capitalize">
              {user?.roleDetails?.name || user?.role || "Role not assigned"}
            </div>
            {/* {user?.tenantDetails && (
              <div className="text-sm text-gray-400">
                Company(Tenant): {user.tenantDetails.name}
              </div>
            )} */}

            <Button
              onClick={() => setIsEditing(true)}
              variant="outline"
              className="mt-3"
            >
              <Pencil className="w-4 h-4 mr-1" /> Edit Profile
            </Button>
          </>
        ) : (
          <div className="w-full space-y-3 mt-3">
            <AdminProfileForm handleCancel={() => setIsEditing(false)} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfileCardAdmin;
